module.exports = __webpack_public_path__ + "static/media/tiki-logo.8b7bb59c.png";